import { IconDefinition } from '@fortawesome/fontawesome-svg-core';
import { inject, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DialogLayoutComponent } from './dialog-layout.component';
import { IonicModule } from '@ionic/angular';
import { FaIconLibrary, FontAwesomeModule } from '@fortawesome/angular-fontawesome';

import {
  faXmarkLarge
} from '@fortawesome/pro-light-svg-icons';

const icons: IconDefinition[] = [
  faXmarkLarge
]

@NgModule({
  imports: [
    CommonModule,
    IonicModule,
    FontAwesomeModule
  ],
  declarations: [DialogLayoutComponent],
  exports: [DialogLayoutComponent]
})
export class DialogLayoutModule {
  private readonly _lib: FaIconLibrary = inject(FaIconLibrary);

  constructor() {
    this._lib.addIcons(...icons);
  }
}
